(function() {
    'use strict';

    angular.module('app.proyectos', []);
})();
